module.exports = __webpack_public_path__ + "img/37.a0a8a031.webp";